// 検索されたキーワードをstoreに格納する
export const SAVE_KEYWORD = 'SAVE_KEYWORD';

export const SearchType = {
  QUESTIONS: 'questions',
  STREAM_CONTENTS: 'stream_contents',
};
